export default {
    "serviceOptionCode": "21",
    "planNumber": "805222",
    "productCodes": ["SF"]
}